import React, { createContext, useState, useEffect, useContext } from 'react';
// Assume you have an api service file
import {GetUser} from "../../axios/Axios";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadUser = async () => {
            try {
                const userData = await GetUser();
                setUser(userData.data);
            } catch (error) {
                console.error("Failed to fetch user:", error);
                setUser(null); // Handle case where user isn't logged in
            } finally {
                setIsLoading(false);
            }
        };

        loadUser();
    }, []); // Empty array ensures this runs only once on mount

    return (
        <UserContext.Provider value={{ user, isLoading }}>
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to easily access the user context
export const useUser = () => {
    return useContext(UserContext);
};